module.exports = __webpack_public_path__ + "static/media/logo_idovinabank.7e7d4989.svg";